export default __webpack_public_path__ + "static/media/noise.0473ebbb.png";